export default {
    UEDetail: 118,
    FicheDescriptive: 11901,
    Dashboard: 154,
    Documents: 15402,
    Valves: 15401,
    Contacts: 155,
    Inscriptions: 156,
    Inscription: 157,
    Reinscription: 159,
    PAE: 15907,
    SignaturePAE: 15908,
    NouvelleCommande: 160,
    Commandes: 1601,
    CommandesIntervention: 160102,
    Examens: 161,
    Stages: 162,
    Memoire: 163,
    Consentement: 16301,
    RemiseMemoire: 164,
    InscriptionTP: 177,
    DecretInclusif: 185,
    SignaturePAI: 18502,
    Verifications: 187,
    Absences: 188,
    SAR: 200,
    InformationsRelativesDefenseMemoire: 201,
    Proclamation: 202,
};